import { Layout, Text } from '@loadsmart/loadsmart-ui'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { formatCurrency } from 'core/utils/currency'

import { useConfigContext } from 'config/ui/ConfigContext'

import {
  type AccessorialCharge,
  getAllInRate,
  type QuoteAccessorial,
} from '../domain/QuoteAccessorial'
import {
  formatAccessorialChargeKeyAndName,
  getAccessorialNames,
  formatRequestedAccessorialChargeKeyAndName,
} from '../presenter/quoteAccessorialPresenter'

export type QuoteSubmitSubTotalProps = {
  accessorialCharges: Array<AccessorialCharge>
  quoteAccessorials?: Array<QuoteAccessorial>
  flatRate: number
}

export function QuoteSubmitSubTotal({
  accessorialCharges,
  quoteAccessorials,
  flatRate,
}: QuoteSubmitSubTotalProps) {
  const config = useConfigContext()
  const enablePriceItemTypes = config.enablePriceItemTypes.toBoolean()

  if (accessorialCharges.length > 0) {
    const accessorialNames = enablePriceItemTypes ? {} : getAccessorialNames(quoteAccessorials)

    return (
      <Layout.Stack space="xs" align="flex-start">
        <Text>Flat Rate: {formatCurrency(flatRate)}</Text>
        {accessorialCharges.map(accessorialCharge => {
          const { key, name } = enablePriceItemTypes
            ? formatRequestedAccessorialChargeKeyAndName(accessorialCharge)
            : formatAccessorialChargeKeyAndName(accessorialCharge, accessorialNames)

          return (
            <Text key={key}>
              {name}: {accessorialCharge.rate > 0 ? formatCurrency(accessorialCharge.rate) : '$ -'}
            </Text>
          )
        })}
        <Text>--------------------------------------------------</Text>
        <Text variant="heading-sm-bold">
          Total: {formatCurrency(getAllInRate(accessorialCharges, flatRate))}
        </Text>
        <Text
          color="color-neutral-dark"
          style={{ textAlign: 'left', paddingTop: getToken('spacing-2') }}
        >
          *Breaking down the rates may increase your chances to receive final proposals.
        </Text>
      </Layout.Stack>
    )
  }
  return (
    <Text variant="heading-sm">
      Rate: <Text variant="heading-sm-bold">{formatCurrency(flatRate)}</Text>
    </Text>
  )
}
